// extracted by mini-css-extract-plugin
export default {"no-results":"NoResults_no-results__VV-lz","title":"NoResults_title__wt4vD","more-info":"NoResults_more-info__HPcaK","loading-value":"NoResults_loading-value__-QLX8"};